import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { PropertyRecord, ITableCell } from '../../../../shared/models';
import { TaskType } from '../../../../shared/enums';
import { ZoningCodeService, InstanceService } from '../../services';

import * as _ from 'lodash';
import { TaskService } from '../../services/task.service';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../../constants';
import { PageEvent } from '@angular/material/paginator';

@Component({
    standalone: false,
    selector: 'app-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit, OnDestroy {
    tasks: ITaskModel[] = [];

    DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    DEFAULT_PAGE_SIZE_OPTIONS = DEFAULT_PAGE_SIZE_OPTIONS;
    pageEvent: PageEvent;

    showSpinner: boolean;

    propertyRecords: Observable<PropertyRecord[]>;

    taskColumns: ITableCell[] = [
        { property: 'actualVersion', title: 'Actual Version' }
    ];

    taskColumnsToDisplay: string[] = [
        'instanceName',
        'zoningCodeName',
        ...this.taskColumns.map(zcvCell => zcvCell.property),
        'status',
        'actions'
    ];

    subscriptions: Subscription[] = [];

    constructor(
        private taskService: TaskService,
        private instanceService: InstanceService,
        private zoningCodeService: ZoningCodeService
    ) { }

    get totalJobsCount() {
        return this.taskService.totalActiveTasksCount;
    }

    ngOnInit() {
        this.taskService.processes.subscribe(tasks => {
            this.tasks = tasks;
            const zcsToLoad = this.getNeededZoningCodesToLoad();
            if (zcsToLoad && zcsToLoad.length) {
                this.zoningCodeService.getZoningCodesByIds(zcsToLoad).subscribe();
            }
        });
        this.showSpinner = true;
        this.taskService
            .getAllTasks()
            .subscribe(() => {
                this.showSpinner = false;
            });

        this.subscriptions.push(
            this.taskService
                .processesListChanged
                .subscribe((_value) => {
                    this.pageChanged(this.pageEvent);
                })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => !subscription.closed && subscription.unsubscribe());
    }

    showTask(task: ITaskModel) {
        return [
            TaskType.ZC_VERSION_CALCULATION,
            TaskType.ZONING_CODE_INDEXING,
            TaskType.ZONING_CODE_INDEXING_WITH_CURSOR
        ].indexOf(task.type) >= 0;
    }

    getInstanceName(task: ITaskModel) {
        const instance = this.instanceService.getInstanceById(task.instanceId);
        return _.get(instance, 'Name');
    }

    getZoningCodeName(task: ITaskModel) {
        const zc = this.zoningCodeService.getZoningCodeById(task.zoningCodeId);
        return zc ? zc.Name : '';
    }

    private getNeededZoningCodesToLoad() {
        const result = this.tasks.map(task => {
            const zc = this.zoningCodeService.getZoningCodeById(task.zoningCodeId);
            if (!zc) {
                return { Id: task.zoningCodeId, State: task.state };
            }
        });

        return _.uniqBy(result, 'Id').filter(e => e);
    }

    pageChanged(event: PageEvent) {
        this.pageEvent = event;
        this.showSpinner = true;
        this.taskService
            .getAllTasks(
                _.get(event, 'pageIndex', 0) + 1,
                _.get(event, 'pageSize')
            )
            .subscribe(() => {
                this.showSpinner = false;
            });
    }
}
